var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('one-cms-product-fetcher-component',{attrs:{"id":_vm.productId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var product = ref.product;
var isLoading = ref.isLoading;
return [_c('one-cms-dynamic-component',_vm._b({attrs:{"html":_vm.content,"product":product,"is-loading":isLoading}},'one-cms-dynamic-component',_vm.$attrs,false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }